"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var CardStyled = (0, _styledComponents.default)('article').withConfig({
  displayName: "Card__CardStyled",
  componentId: "nvn4un-0"
})(["", " ", " ", " ", " ", " ", ""], _styledSystem.border, _styledSystem.space, _styledSystem.color, _styledSystem.shadow, _styledSystem.layout, _styledSystem.opacity);

var Card = function Card(props) {
  var children = props.children;
  return _react.default.createElement(CardStyled, (0, _extends2.default)({
    borderRadius: [3],
    paddingX: [2, 2, 3],
    paddingY: [2],
    boxShadow: 1,
    backgroundColor: "white"
  }, props), children);
};

exports.Card = Card;